define('presentation/welcome/viewModels/onboardingSchedulingViewModel',[
    'businessServices/authentication/accountPlanInfo',
    'businessServices/authentication/sessionWorkflowFlags',
    'common/promises/promiseFactory',
    'plugins/router',
    'presentation/common/window/windowControl',
    'presentation/welcome/common/onboardingNavigationManager',
    'settings/navigationConfiguration'
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _accountPlanInfo = require('businessServices/authentication/accountPlanInfo');
        const _i18n = require('i18next');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('plugins/router');
        const _sessionWorkflowFlags = require('businessServices/authentication/sessionWorkflowFlags');
        const _windowControl = require('presentation/common/window/windowControl');
        const OnboardingNavigationManagerConstructor = require('presentation/welcome/common/onboardingNavigationManager');

        let _onboardingNavigationManager = null;

        const MEETINGS_EMBED_SCRIPT_URL = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
        const MEETINGS_EMBED_SCRIPT_MARKER = 'data-patlive-meetings-embed';

        self.isCompositionComplete = ko.observable(false);
        self.isCompactContentContainer = true;
        self.schedulerEmbedUrl = ko.observable('');

        self.continueButtonText = _i18n.t('onboardingScheduling:continueToAccount');

        self.onContinue = () => {
            if (_sessionWorkflowFlags.isSchedulingAfterOnboardingWizard()) {
                _router.navigate(_navigationConfiguration.signupLandingPage);
                return;
            }
            // Back to wherever the snackbar was clicked; home when there's no record of that, such as
            // after a reload or arriving by URL.
            _onboardingNavigationManager.navigateToPreOnboardingPageOrHome();
        };

        // Reported by the HubSpot embed rather than by the customer reaching this page or leaving
        // it, so an abandoned scheduler never records a booking.
        self.onBookingSucceeded = () => {
            _accountPlanInfo.setOnboardingScheduled();
        };

        self.onPrimaryActionClicked = () => {
            return _promiseFactory.deferWithMinimumWait(deferredObject => {
                self.onContinue();
                deferredObject.resolve({ keepSpinning: true });
            });
        };

        const _removeMeetingsEmbedScript = () => {
            const existing = document.querySelectorAll('script[' + MEETINGS_EMBED_SCRIPT_MARKER + ']');
            Array.prototype.forEach.call(existing, (script) => script.parentNode.removeChild(script));
        };

        const _loadMeetingsEmbedScript = () => {
            _removeMeetingsEmbedScript();

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = MEETINGS_EMBED_SCRIPT_URL;
            script.setAttribute(MEETINGS_EMBED_SCRIPT_MARKER, 'true');
            document.body.appendChild(script);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
            _loadMeetingsEmbedScript();
        };

        self.detached = () => {
            _removeMeetingsEmbedScript();
            _sessionWorkflowFlags.isSchedulingAfterOnboardingWizard(false);
        };

        self.activate = () => {
            _onboardingNavigationManager = new OnboardingNavigationManagerConstructor();

            return _initialize();
        };

        const _initialize = () => {
            self.schedulerEmbedUrl(_windowControl.getOnboardingAppointmentUrl() + '?embed=true');

            return _promiseFactory.wait();
        };
    };
});
